'use strict';

require('./ImageDownloadService');
require('./KayleeService');
require('./RoomService');
var Sass = require('../node_modules/sass.js/dist/sass.js');
var log = require('../../log/Log').channel('ThemeService');

angular.module('inara').factory('ThemeService', ThemeService);

ThemeService.$inject = ['RoomService', 'KayleeService', '$http', '$q',
                        '$rootScope', 'ImageDownloadService'];

function ThemeService(RoomService, KayleeService, $http, $q, 
                      $rootScope, ImageDownloadService) {
    var room = null;
    var site = null;
    var theme = null;
    var themeStyle = '';
    var isCompiling = false;
    var queuedCompileRequest = null;
    var mixinsSrc;
    var themeSrc;
    var images = { logo: null, backgroundImage: null };

    var mixinsDeferred = $http.get('theme/_mixins.scss');
    mixinsDeferred.success(function(result) {
        mixinsSrc = result;
    });
    var themeDeferred = $http.get('theme/_theme.scss');
    themeDeferred.success(function(result) {
        themeSrc = result;
    });

    log.info('initializing');

    Sass.setWorkerUrl('./js/sass.worker.js');
    var sass = new Sass();
    RoomService.onOnlineChanged(onRoomServiceOnlineChanged);

    return {
        getImageUrl: getImageUrl,
    	getThemeStyle: getThemeStyle,
        isThemeCompiling: isThemeCompiling
    };

    function isThemeCompiling() { 
        return isCompiling; 
    }

    function onRoomServiceOnlineChanged(online) {
        if (online) {
            room = RoomService.getRoom();
            site = KayleeService.getSite(room.siteId);
            site.$onChange(onSiteChanged);
        } else {
            room = null;
            if (site !== null) {
            	site.$offChange(onSiteChanged);
            }
            site = null;
            theme = null;
        }
    }

    function onSiteChanged() {
        var newTheme = copyTheme(site.visualTheme);

        downloadImages();

        if (angular.equals(theme, newTheme))  {
            if (theme === null) {
                themeStyle = '';
            }
            return;
        }
        if (newTheme === null) {
            log.error('theme removed from database, using previously compiled theme');
            return;
        }
        theme = newTheme;
        requestCompileThemeStyle();
    }

    // Make a copy of the visual theme. Ignore any FirebaseStorage objects.
    function copyTheme(theme) {
        if (typeof theme === 'undefined' || theme === null) return null;
        var themeCopy = {};
        for (var prop in theme) {
            if (!theme.hasOwnProperty(prop)) continue;
            if (typeof theme[prop] === 'object') continue;
            themeCopy[prop] = theme[prop];
        }

        if (Object.keys(themeCopy).length === 0) return null;
        return themeCopy;
    }

    function downloadImages() {
        for (var name in images) {
            if (!images.hasOwnProperty(name)) continue;

            if (!site.hasOwnProperty('visualTheme') ||
                !site.visualTheme.hasOwnProperty(name) ||
                site.visualTheme[name].key === null) {
                images[name] = null;
            } else {
                if (images[name] === null ||
                    images[name].key !== site.visualTheme[name].key) {
                    var storageObject = site.visualTheme[name];
                    images[name] = {
                        key: storageObject.key,
                        url: null
                    };
                    ImageDownloadService.downloadImage(images, storageObject, name);
                }
            }
        }
    }

    function getImageUrl(name) {
        var url = null;
    
        if (images.hasOwnProperty(name) && images[name] !== null &&
            images[name].url !== null) {
            return images[name].url;
        }

        return url;
    }

    function requestCompileThemeStyle() {
        if (isCompiling) {
            if (queuedCompileRequest !== null) {
                log.debug('replacing existing queuedCompileRequest = ' + queuedCompileRequest.timestamp);
            }
            queuedCompileRequest = { timestamp: Date.now };
        }
        else {
            compileThemeStyle();
        }
    }

    function compileThemeStyle() {
    	log.debug('compiling theme...');

        if (theme === null) {
            log.warning('theme was null');
            return;
        }

        isCompiling = true;
	    var themeVars = 
	    	'$theme-primary: ' + theme.colorPrimary + ';\n' +
            '$theme-secondary: ' + theme.colorSecondary + ';\n' + 
	    	'$theme-highlight: ' + theme.colorHighlight + ';\n' +
	    	'$theme-light-highlight: ' + theme.colorLightHighlight + ';\n' +
	    	'$theme-text-primary: ' + theme.colorTextPrimary + ';\n' +
            '$theme-text-secondary: ' + theme.colorTextSecondary + ';\n' +
            '$theme-text-highlight: ' + theme.colorTextHighlight + ';\n' +
            '$theme-text-light-highlight: ' + theme.colorTextLightHighlight + ';\n' +
            '$theme-text-background: ' + theme.colorTextBackground + ';\n' + 
	    	'$theme-background: ' + theme.colorBackground + ';\n';
	    $q.all([mixinsDeferred, themeDeferred]).then(function() {
	    	sass.compile(themeVars + '\n' + mixinsSrc + '\n' + themeSrc, function(result) {
	    		if (result.status !== 0) {
                    if (angular.isDefined(result.error)) {
                        log.error(result.error);
                    }
                    if (angular.isDefined(result.message)) {
                        log.error(result.message);
                    }
	    			themeStyle = '';
	    		} else {
		    		themeStyle = result.text;
	    		}
                if (queuedCompileRequest !== null) {
                    log.debug('processing queuedCompileRequest = ' + queuedCompileRequest.timestamp);
                    queuedCompileRequest = null;
                    compileThemeStyle();
                }
                log.debug('theme compilation completed');
                $rootScope.$apply(function() {
                    isCompiling = false;
                });
	    	});
	    });
    }

    function getThemeStyle () {
    	return themeStyle;
    }
}